import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faUsers, faEnvelope, faCalendarDays, faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar-component.scss']
})
export class AppSidebarComponent {
  constructor(private _router: Router) { }
  name: string;
  private _url: string;

  faUsers = faUsers;
  faEnvelope = faEnvelope;
  faCalendarDays = faCalendarDays;

  ngOnInit(): void {
    this._url = this._router.url;
  }

  administration = [
    {
      name: 'signaletique.signaletique',
      url: "/admin/signaletique",
      icon: this.faUsers
    },
    {
      name: 'signaletique.email',
      url: "/admin/email",
      icon: this.faEnvelope
    }
  ];

  agenda = [
    {
      name: 'agenda.agenda',
      url: "/presta/agenda",
      icon: this.faCalendarDays
    }
  ]

  // currentMenuPage() {

  // }

  getCurrentUrl() {
    this._url = this._router.url;
  }

}
